import { z } from "zod";

const allowedProtocols = ["http", "https"];
const protocolRegex = /^(\w+):\/\//;
const urlSchema = z
  .string()
  .trim()
  .refine((x) => {
    // If the URL has a protocol, it must be allowed
    const protocol = protocolRegex.exec(x)?.[1];
    return !protocol || allowedProtocols.includes(protocol.toLowerCase());
  })
  .transform((x) => {
    // If the URL doesn't have a protocol, add one
    const protocol = protocolRegex.exec(x)?.[1];
    return protocol ? x : `https://${x}`;
  })
  .pipe(z.string().url());

export function sanitizeUrl(value: unknown): string | undefined {
  const result = urlSchema.safeParse(value);
  return result.success ? result.data : undefined;
}
